import * as z from 'zod'
import { ToManyRelation } from '~/shared/api/core'
import { Post } from '~/shared/api/post'
import { Option } from '~/shared/config/constants'
import { dateSchema, uuidOptionsSchema } from '~/shared/lib/schemas'

import { isString } from '~/shared/lib/utils'
import { ApiModel } from './core'

const attributeSchema = z.object({
  title: z.string().optional().nullable(),
  content: z.string().optional().nullable(),
  isActive: z.boolean(),
  sort: z.string().transform(Number),
  image: z.object({
    url: z.string(),
    uuid: z.string(),
  }),
})

const relationsSchema = z.object({
  rolesIds: uuidOptionsSchema,
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)
  .merge(relationsSchema)

export type StoryAttributes = z.infer<typeof schema>

export class Story extends ApiModel<typeof schema> {
  static jsonApiType = 'stories'

  static schema = schema

  getTitle(): string {
    return this.getAttribute('title')
  }
  getContent(): string {
    return this.getAttribute('content')
  }
  getSort(): string {
    return this.getAttribute('sort')
  }
  getImage(): string {
    const image = this.getAttribute('image')
    return image?.url
  }

  posts(): ToManyRelation<Post, this> {
    return this.hasMany(Post)
  }
  getPosts(): Post[] {
    return this.getRelation('posts') ?? []
  }
  setPosts(ids: UniqueId[] | Option[]) {
    let posts: Post[] = []
    ids.map((postId) => {
      const post = new Post()
      if (isString(postId)) {
        post.setApiId(postId)
        posts = posts.concat(post)
      }
    })
    this.setRelation('roles', posts)
  }
}
